/*
 *
 * This is a hack way to mock env from request query
 * Basically, it should be used as develop or test.
 * In production, you should use info from DOM window.
 *
 */

export function extractFromQuery(queryString) {
  const searchParams = new URLSearchParams(queryString)

  return {
    isXHS: searchParams.get('clientsource') === 'app',
    isMiniprogram: searchParams.get('isMiniprogram') === 'true',
    isFullscreen: searchParams.get('fullscreen') === 'true',
    isNaviHidden: searchParams.get('naviHidden') === 'yes',
    isThemeDark: searchParams.get('themeType') === 'dark',
  }
}
